/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState, forwardRef, ForwardedRef, useEffect } from 'react';

import { TextInput } from '@client/new/pages/promotions/view/components/TextInput';
import { formatTime, parseTimeClamped } from './format-time';

type TimeInputProps = {
  value?: number;
  onChange: (e: { target: { value: number } }) => void;
  name?: string;
  min: number;
  max: number;
  [key: string]: any;
};

export const TimeInput = forwardRef(
  (p: TimeInputProps, ref: ForwardedRef<HTMLInputElement>) => {
    const { value, onChange, onBlur, min, max, ...rest } = p;
    const [inputValue, setInputValue] = useState<string>('');
    const [isUserEditing, setIsUserEditing] = useState(false);
    const [isFocused, setIsFocused] = useState(false);

    useEffect(() => {
      if (!isUserEditing && !isFocused) {
        setInputValue(formatTime(value || min));
      }
    }, [value, min, isUserEditing, isFocused]);

    const handleTimeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      setIsUserEditing(true);
      setInputValue(e.target.value);
    };

    const handleTimeBlur = (e: React.FocusEvent<HTMLInputElement>) => {
      setIsUserEditing(false);
      setIsFocused(false);

      if (!inputValue) return;

      const value = parseTimeClamped({
        input: e.target.value,
        min,
        max,
      });
      const ev = { target: { value } };
      onChange(ev);
      setInputValue('');
      onBlur?.(ev);
    };

    return (
      <TextInput
        {...rest}
        ref={ref}
        type="text"
        value={
          isUserEditing && isFocused ? inputValue : formatTime(value || min)
        }
        onBlur={handleTimeBlur}
        onChange={handleTimeChange}
        onFocus={() => setIsFocused(true)}
        placeholder="00:00"
      />
    );
  },
);
